import { Button, Card, HeadingFour, maxWidth } from 'hui';
import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  margin-bottom: 20px;
`;

const VerticallyAligned = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  ${maxWidth('md')} {
    flex-direction: column;
  }
`;

const Spacer = styled.span`
  padding: 0.5rem;
  display: inline-block;
`;

declare interface InlineProp {
  href: String;
  description: String;
  btnText: String;
}

export const InlineBannerCta: React.FC<InlineProp> = ({ href, description, btnText }) => (
  <Wrap>
    <Card color="tint1" mb={0}>
      <VerticallyAligned>
        <HeadingFour mb={0} block color="tint6">
          {description}
        </HeadingFour>
        <Spacer />
        <Button as="a" href={href}>
          {btnText !== undefined ? btnText : 'Get Quotes'}
        </Button>
      </VerticallyAligned>
    </Card>
  </Wrap>
);
